import React, { useState, useEffect } from 'react';
import { api } from '../services/api';
import './Analytics.css';

const Analytics = () => {
  const [analyticsData, setAnalyticsData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [sortConfig, setSortConfig] = useState({ key: null, direction: 'asc' });
  const [searchTerm, setSearchTerm] = useState('');

  useEffect(() => {
    const fetchAnalytics = async () => {
      try {
        // For now, using mock data. Replace with actual API call when available
        const mockData = {
          "message": "Performance statistics for all active assistants retrieved successfully.",
          "data": {
            "total_assistants": 17,
            "performance_statistics": [
              {
                "assistant_id": "asst_tr_honda_8970e998e18f47f8",
                "total_leads": 15,
                "leads_per_day": 0.7142857142857143,
                "total_conversations": 82,
                "total_conversion_percentage": 18.29268292682927,
                "last_30_days_conversations": 80,
                "last_30_days_conversion_rate": 18.75,
                "last_30_days_leads": 15,
                "status": "green"
              },
              {
                "assistant_id": "asst_groupecouture_leviko_a6de885db83142fe",
                "total_leads": 14,
                "leads_per_day": 0.5384615384615384,
                "total_conversations": 90,
                "total_conversion_percentage": 15.555555555555555,
                "last_30_days_conversations": 90,
                "last_30_days_conversion_rate": 15.555555555555555,
                "last_30_days_leads": 14,
                "status": "yellow"
              },
              {
                "assistant_id": "asst_mKITnTGChaP7zEefxtvavXbR",
                "total_leads": 50,
                "leads_per_day": 0.49019607843137253,
                "total_conversations": 363,
                "total_conversion_percentage": 13.774104683195592,
                "last_30_days_conversations": 138,
                "last_30_days_conversion_rate": 11.594202898550725,
                "last_30_days_leads": 16,
                "status": "yellow"
              },
              {
                "assistant_id": "asst_rmmotosport_983gwug",
                "total_leads": 14,
                "leads_per_day": 0.1917808219178082,
                "total_conversations": 98,
                "total_conversion_percentage": 14.285714285714285,
                "last_30_days_conversations": 41,
                "last_30_days_conversion_rate": 14.634146341463413,
                "last_30_days_leads": 6,
                "status": "red"
              },
              {
                "assistant_id": "asst_toyotabaiedeschaleurs_f1f0fb165f224b52",
                "total_leads": 12,
                "leads_per_day": 0.16,
                "total_conversations": 124,
                "total_conversion_percentage": 9.67741935483871,
                "last_30_days_conversations": 22,
                "last_30_days_conversion_rate": 22.727272727272727,
                "last_30_days_leads": 5,
                "status": "red"
              },
              {
                "assistant_id": "asst_groupepoirier_chrysler_0b2dcda0b92f49ec",
                "total_leads": 2,
                "leads_per_day": 0.125,
                "total_conversations": 16,
                "total_conversion_percentage": 12.5,
                "last_30_days_conversations": 8,
                "last_30_days_conversion_rate": 25,
                "last_30_days_leads": 2,
                "status": "red"
              },
              {
                "assistant_id": "asst_groupeveloce_rdlmitsubishi_1959a2f9bee24112",
                "total_leads": 4,
                "leads_per_day": 0.11764705882352941,
                "total_conversations": 14,
                "total_conversion_percentage": 28.57142857142857,
                "last_30_days_conversations": 8,
                "last_30_days_conversion_rate": 25,
                "last_30_days_leads": 2,
                "status": "red"
              },
              {
                "assistant_id": "asst_gaspesiehyundai_596e9a9054ec4f39",
                "total_leads": 7,
                "leads_per_day": 0.09859154929577464,
                "total_conversations": 51,
                "total_conversion_percentage": 13.725490196078432,
                "last_30_days_conversations": 8,
                "last_30_days_conversion_rate": 37.5,
                "last_30_days_leads": 3,
                "status": "red"
              },
              {
                "assistant_id": "asst_groupeveloce_temischevrolet_df4c2ef16f1a49fa",
                "total_leads": 4,
                "leads_per_day": 0.08888888888888889,
                "total_conversations": 9,
                "total_conversion_percentage": 44.44444444444444,
                "last_30_days_conversations": 7,
                "last_30_days_conversion_rate": 42.857142857142854,
                "last_30_days_leads": 3,
                "status": "red"
              },
              {
                "assistant_id": "asst_groupeveloce_d7027b59345648b5",
                "total_leads": 2,
                "leads_per_day": 0.06451612903225806,
                "total_conversations": 5,
                "total_conversion_percentage": 40,
                "last_30_days_conversations": 2,
                "last_30_days_conversion_rate": 50,
                "last_30_days_leads": 1,
                "status": "red"
              },
              {
                "assistant_id": "asst_groupeveloce_temischrysler_02d32d485968417b",
                "total_leads": 2,
                "leads_per_day": 0.05405405405405406,
                "total_conversations": 3,
                "total_conversion_percentage": 66.66666666666666,
                "last_30_days_conversations": 2,
                "last_30_days_conversion_rate": 50,
                "last_30_days_leads": 1,
                "status": "red"
              },
              {
                "assistant_id": "asst_groupepoirier_nissan_999aac5ddf69458a",
                "total_leads": 0,
                "leads_per_day": 0,
                "total_conversations": 1,
                "total_conversion_percentage": 0,
                "last_30_days_conversations": 1,
                "last_30_days_conversion_rate": 0,
                "last_30_days_leads": 0,
                "status": "red"
              },
              {
                "assistant_id": "asst_groupepoirier_hyundai_126b2ed32fa6499e",
                "total_leads": 0,
                "leads_per_day": 0,
                "total_conversations": 3,
                "total_conversion_percentage": 0,
                "last_30_days_conversations": 3,
                "last_30_days_conversion_rate": 0,
                "last_30_days_leads": 0,
                "status": "red"
              },
              {
                "assistant_id": "asst_groupeveloce_cliccredit_9d84e63bc92c4e38",
                "total_leads": 0,
                "leads_per_day": 0,
                "total_conversations": 1,
                "total_conversion_percentage": 0,
                "last_30_days_conversations": 1,
                "last_30_days_conversion_rate": 0,
                "last_30_days_leads": 0,
                "status": "red"
              },
              {
                "assistant_id": "asst_groupepoirier_kia_aaa25cdbede647bb",
                "total_leads": 0,
                "leads_per_day": 0,
                "total_conversations": 1,
                "total_conversion_percentage": 0,
                "last_30_days_conversations": 1,
                "last_30_days_conversion_rate": 0,
                "last_30_days_leads": 0,
                "status": "red"
              },
              {
                "assistant_id": "asst_amostoyota_6b8d910d16ca462b",
                "total_leads": 0,
                "leads_per_day": 0,
                "total_conversations": 6,
                "total_conversion_percentage": 0,
                "last_30_days_conversations": 6,
                "last_30_days_conversion_rate": 0,
                "last_30_days_leads": 0,
                "status": "red"
              },
              {
                "assistant_id": "asst_groupepoirier_mazda_0332001d3a304e25",
                "total_leads": 0,
                "leads_per_day": 0,
                "total_conversations": 1,
                "total_conversion_percentage": 0,
                "last_30_days_conversations": 1,
                "last_30_days_conversion_rate": 0,
                "last_30_days_leads": 0,
                "status": "red"
              }
            ]
          }
        };
        
        setAnalyticsData(mockData.data);
        setLoading(false);
        
        // Uncomment this when the actual API endpoint is available:
        // const response = await api.get('v1/analytics/performance');
        // setAnalyticsData(response.data.data);
        // setLoading(false);
      } catch (err) {
        setError('Error fetching analytics data');
        setLoading(false);
      }
    };

    fetchAnalytics();
  }, []);

  const getStatusIcon = (status) => {
    switch (status) {
      case 'green':
        return '🟢';
      case 'yellow':
        return '🟡';
      case 'red':
        return '🔴';
      case 'dark green':
        return '🟢'; // Using same green for now, can be changed to a different icon
      default:
        return '⚪';
    }
  };

  const getStatusText = (status) => {
    switch (status) {
      case 'green':
        return 'bon';
      case 'yellow':
        return 'correct';
      case 'red':
        return 'mauvais';
      case 'dark green':
        return 'excellent';
      default:
        return status;
    }
  };

  const formatPercentage = (value) => {
    return `${value.toFixed(2)}%`;
  };

  const formatNumber = (value) => {
    return value.toFixed(2);
  };

  const handleSort = (key) => {
    let direction = 'asc';
    if (sortConfig.key === key && sortConfig.direction === 'asc') {
      direction = 'desc';
    }
    setSortConfig({ key, direction });
  };

  const filteredAndSortedData = React.useMemo(() => {
    if (!analyticsData?.performance_statistics) return [];
    
    // First filter by search term
    let filteredItems = analyticsData.performance_statistics.filter(assistant =>
      assistant.assistant_id.toLowerCase().includes(searchTerm.toLowerCase())
    );
    
    // Then sort
    if (sortConfig.key) {
      filteredItems.sort((a, b) => {
        if (a[sortConfig.key] < b[sortConfig.key]) {
          return sortConfig.direction === 'asc' ? -1 : 1;
        }
        if (a[sortConfig.key] > b[sortConfig.key]) {
          return sortConfig.direction === 'asc' ? 1 : -1;
        }
        return 0;
      });
    }
    return filteredItems;
  }, [analyticsData, sortConfig, searchTerm]);

  if (loading) return <div className="loading">Loading analytics...</div>;
  if (error) return <div className="error">{error}</div>;

  return (
    <div className="analytics">
      <h2>Analytics Dashboard</h2>
      
      {analyticsData && (
        <div className="analytics-summary">
          <div className="summary-card">
            <h3>Total Assistants</h3>
            <p className="summary-number">{analyticsData.total_assistants}</p>
          </div>
          <div className="summary-card">
            <h3>Filtered Results</h3>
            <p className="summary-number">{filteredAndSortedData.length}</p>
          </div>
        </div>
      )}

      <div className="search-container">
        <input
          type="text"
          placeholder="Search by Assistant ID..."
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
          className="search-input"
        />
        {searchTerm && (
          <button 
            onClick={() => setSearchTerm('')}
            className="clear-search"
          >
            Clear
          </button>
        )}
      </div>

      <div className="analytics-table-container">
        <table className="analytics-table">
          <thead>
            <tr>
              <th onClick={() => handleSort('assistant_id')}>
                Assistant ID {sortConfig.key === 'assistant_id' && (sortConfig.direction === 'asc' ? '↑' : '↓')}
              </th>
              <th onClick={() => handleSort('status')}>
                Status {sortConfig.key === 'status' && (sortConfig.direction === 'asc' ? '↑' : '↓')}
              </th>
              <th onClick={() => handleSort('total_leads')}>
                Total Leads {sortConfig.key === 'total_leads' && (sortConfig.direction === 'asc' ? '↑' : '↓')}
              </th>
              <th onClick={() => handleSort('leads_per_day')}>
                Leads/Day {sortConfig.key === 'leads_per_day' && (sortConfig.direction === 'asc' ? '↑' : '↓')}
              </th>
              <th onClick={() => handleSort('total_conversations')}>
                Total Conversations {sortConfig.key === 'total_conversations' && (sortConfig.direction === 'asc' ? '↑' : '↓')}
              </th>
              <th onClick={() => handleSort('total_conversion_percentage')}>
                Total Conversion % {sortConfig.key === 'total_conversion_percentage' && (sortConfig.direction === 'asc' ? '↑' : '↓')}
              </th>
              <th onClick={() => handleSort('last_30_days_conversations')}>
                30d Conversations {sortConfig.key === 'last_30_days_conversations' && (sortConfig.direction === 'asc' ? '↑' : '↓')}
              </th>
              <th onClick={() => handleSort('last_30_days_conversion_rate')}>
                30d Conversion % {sortConfig.key === 'last_30_days_conversion_rate' && (sortConfig.direction === 'asc' ? '↑' : '↓')}
              </th>
              <th onClick={() => handleSort('last_30_days_leads')}>
                30d Leads {sortConfig.key === 'last_30_days_leads' && (sortConfig.direction === 'asc' ? '↑' : '↓')}
              </th>
            </tr>
          </thead>
          <tbody>
            {filteredAndSortedData.map((assistant, index) => (
              <tr key={assistant.assistant_id} className={`status-${assistant.status.replace(' ', '-')}`}>
                <td className="assistant-id">{assistant.assistant_id}</td>
                <td className="status-cell">
                  <span className="status-icon">{getStatusIcon(assistant.status)}</span>
                  <span className="status-text">{getStatusText(assistant.status)}</span>
                </td>
                <td>{assistant.total_leads}</td>
                <td>{formatNumber(assistant.leads_per_day)}</td>
                <td>{assistant.total_conversations}</td>
                <td>{formatPercentage(assistant.total_conversion_percentage)}</td>
                <td>{assistant.last_30_days_conversations}</td>
                <td>{formatPercentage(assistant.last_30_days_conversion_rate)}</td>
                <td>{assistant.last_30_days_leads}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default Analytics; 